module.exports = __webpack_public_path__ + "img/text-mark9.1e38c160.png";